import { getConversationIdCookie } from "utils/cookie";

export const getSurveyUrl = (surveyUrls, userSwid, swidDefault = "") => {
	const surveyParams = [];
	const swid = userSwid || swidDefault;
	const conversationId = getConversationIdCookie();
	const visitorId = window.WDPRO?.Analytics?.Exports?.VisitorId;

	if (swid) {
		surveyParams.push(`SWID=${swid}`);
	}
	if (conversationId) {
		surveyParams.push(`CID=${conversationId}`);
	}
	if (visitorId) {
		surveyParams.push(`VI=${visitorId}`);
	}

	const surveyUrl =
		surveyUrls?.[Math.floor(Math.random() * surveyUrls?.length)];

	return `${surveyUrl}${
		surveyParams.length ? (surveyUrl.includes("?") ? "&" : "?") : ""
	}${surveyParams.join("&")}`;
};
